/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineExTankService() {
        let exTankService = {};
        exTankService.getExTankOrders = function (request) {
            return axios.post("/api/ExTankService/GetExTankOrders", request);
        };
        exTankService.getExTankOrder = function (orderExTankId) {
            return axios.get("/api/ExTankService/GetExTankOrder?orderExTankId=" + orderExTankId);
        };
        exTankService.getExTankOrderByOrderId = function (orderId) {
            return axios.get("/api/ExTankService/GetExTankOrderByOrderId?orderId=" + orderId);
        };
        exTankService.acceptOrRejectExTankOrder = function (formData) {
            return axios.post("/api/ExTankService/AcceptOrRejectExTankOrder", formData, { headers: {'Content-Type': 'multipart/form-data' }});
        };
        exTankService.addOrUpdateExTankOrder = function (request) {
            return axios.post("/api/ExTankService/AddOrUpdateExTankOrder", request);
        };
        exTankService.markOrderAsInPendingInvoice = function (request) {
            return axios.post("/api/ExTankService/MarkOrderAsInPendingInvoice", request);
        };
        exTankService.completeExTankOrder = function (request) {
            return axios.post("/api/ExTankService/CompleteExTankOrder", request);
        };
        exTankService.getExTankCompanyProductPricesForZone = function (request) {
            return axios.post("/api/ExTankService/GetExTankCompanyProductPricesForZone", request);
        };
        exTankService.downloadExTankDocument = function (orderId, documentTypeId) {
            var win = window.open("/api/ExTankService/DownloadExTankDocument?orderId=" + orderId + "&documentTypeId=" + documentTypeId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
            //return axios.get("/api/ExTankService/DownloadExTankDocument?orderId=" + orderId + "&documentTypeId=" + documentTypeId, { responseType: 'blob' });
        };
        exTankService.getExTankOrdersAsExcelDocument = function (request) {
            return axios.post("/api/ExTankService/GetExTankOrdersAsExcelDocument", request, { responseType: 'blob' });
        };
        exTankService.getExTankOrderAsPdf = function (orderId) {
            var win = window.open("/api/ExTankService/GetExTankOrderAsPdf?orderId=" + orderId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
        };
        return exTankService;
    }
    //define globally if it doesn't already exist
    if (typeof (exTankService) === "undefined") {
        window.exTankService = defineExTankService();
    } else {
        console.log("exTankService already defined.");
    }
})(window);